/**
 * Hack method to require a module without Webpack bundling it before hand
 * Used so we can use code that use libraries on the server without sending to/getting an error on the client
 * @param pkg the name of the library/file to require
 * @returns the output of require
 */
export function ServerRequire<T>(pkg: string): T {
  if (!IS_SERVER) {
    throw new Error('ServerRequire was used on client!');
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return __non_webpack_require__(pkg);
}
